<template>
  <div>
    <!-- <sidebar> -->
    <div class="sidebar waajo-nav-sidebar" id="sidebar">
      <div class="sidebar-inner" id="style-15">
        <vue-custom-scrollbar class="scroll-area" :settings="settings" @ps-scroll-x="scrollHanle">
          <div id="sidebar-menu" class="sidebar-menu">
            <ul>
              <li class="menu-title">
                <span>Main</span>
              </li>

              <li v-if="isOwner" :class="{ 'active': isDashboardRoute }">
                <router-link to="/" class="contacts" title="Beranda">
                  <i class="la la-bar-chart"></i>
                  <span>Beranda</span>
                </router-link>
              </li>
              <li v-else :class="{ 'active': currentpage === '/employeedashboard' }">
                <router-link to="/employeedashboard" class="contacts" title="Beranda">
                  <i class="la la-tachometer"></i>
                  <span>Beranda</span>
                </router-link>
              </li>
              <li v-if="isOwner" :class="{ 'active': currentpage === '/license/list' || currentpage === '/license/info' }">
                <router-link to="/license/list" class="contacts" title="Akun WhatsApp">
                  <i class="fa fa-mobile"></i>
                  <span>Akun WhatsApp</span>
                </router-link>
              </li>

              <li class="menu-title">
                <span>Kontak &amp; CRM</span>
              </li>
              <li :class="{ 'active': isContactMenuActive }">
                <router-link to="/contacts-v2" class="contacts" title="Kelola Data Kontak"
                  aria-label="Kelola Data Kontak">
                  <svg class="sidebar-contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"
                    aria-hidden="true">
                    <rect x="3" y="4.5" width="18" height="15" rx="3"></rect>
                    <circle cx="9" cy="10.5" r="2.1"></circle>
                    <path d="M5.8 15.8c.6-1.7 1.8-2.5 3.2-2.5s2.6.8 3.2 2.5"></path>
                    <path d="M15.2 9.5h3.1"></path>
                    <path d="M15.2 12.5h3.1"></path>
                    <path d="M15.2 15.5h2.1"></path>
                  </svg>
                  <span>Kontak</span>
                </router-link>
              </li>
              <li :class="{ 'active': currentpage === '/crm/group/list' }">
                <router-link to="/crm/group/list" class="clients" title="Grup Kontak">
                  <i class="la la-users"></i>
                  <span>Grup Kontak</span>
                </router-link>
              </li>
              <li :class="{ 'active': currentpage === '/automation/birthday-greetings/list' }">
                <router-link to="/automation/birthday-greetings/list" class="contacts" title="Momen Spesial">
                  <i class="fa fa-gift"></i>
                  <span>Momen Spesial</span>
                </router-link>
              </li>
              <li :class="{ 'active': currentpage === '/farm-contact/list' }">
                <router-link to="/farm-contact/list" class="contacts" title="Panen Kontak">
                  <i class="la la-map"></i>
                  <span>Panen Kontak</span>
                </router-link>
              </li>

              <li class="menu-title waajo-section-title waajo-section-title--broadcast">
                <span>Broadcast</span>
              </li>
              <li class="waajo-menu-feature waajo-menu-feature--broadcast" :class="{ 'active': isBroadcastMenuActive }">
                <router-link to="/broadcast-v2" class="contacts" title="Unlimited Broadcast">
                  <i class="la la-paper-plane"></i>
                  <span>Unlimited Broadcast</span>
                </router-link>
              </li>

              <li class="menu-title waajo-section-title waajo-section-title--automation" v-show="isOwner == true">
                <span>Automation</span>
              </li>
              <li v-show="isOwner == true" class="waajo-menu-feature waajo-menu-feature--automation"
                :class="{ 'active': currentpage === '/auto-follow-up' || currentpage === '/auto-follow-up/templates' || currentpage === '/auto-follow-up/detail' || currentpage === '/auto-follow-up/wizard' }">
                <router-link to="/auto-follow-up" class="clients" title="Auto Follow Up">
                  <i class="fa fa-comments"></i>
                  <span>Auto Follow Up</span> <span class="afu-beta-badge">New</span>
                </router-link>
              </li>
              <li v-show="isOwner == true" class="waajo-menu-feature waajo-menu-feature--automation"
                :class="{ 'active': isFormsMenuActive }">
                <router-link to="/forms" class="clients" title="Form Builder">
                  <i class="fa fa-clipboard"></i>
                  <span>Form Builder</span> <span class="afu-beta-badge">New</span>
                </router-link>
              </li>
              <li class="menu-title">
                <span>Pesan &amp; Interaksi</span>
              </li>
              <li v-if="typeof (agentSession.id) != 'undefined' && agentSession.id != ''"
                :class="{ 'active': currentpage === '/omni' }">
                <router-link to="/omni" class="chat" title="Chat Room">
                  <i class="la la-whatsapp"></i>
                  <span>Chat Room</span>
                </router-link>
              </li>
              <li :class="{ 'active': currentpage === '/ticket/list' || currentpage.indexOf('/ticket/detail') === 0 }">
                <router-link to="/ticket/list" class="clients" title="Ticket">
                  <i class="fa fa-ticket"></i>
                  <span>Ticket</span> <span class="afu-beta-badge">New</span>
                </router-link>
              </li>
              <li :class="{ 'active': currentpage === '/automation/quick-reply/list' }">
                <router-link to="/automation/quick-reply/list" class="clients" title="Quick Reply">
                  <i class="la la-flash"></i>
                  <span>Quick Reply</span>
                </router-link>
              </li>
              <li v-show="isOwner == true" :class="{ 'active': currentpage === '/ai-chatbot/overview' }">
                <router-link to="/ai-chatbot/overview" class="contacts" title="AI &amp; Chatbot">
                  <img src="../../assets/sparkle.svg" style="width: 24px; height: 24px;" alt="" />
                  <span>AI &amp; Chatbot</span>
                </router-link>
              </li>




              <li class="menu-title" v-show="isOwner == true">
                <span>Operasional</span>
              </li>
              <li class="submenu" v-show="isOwner == true" :class="{ 'active': isAgentsMenuActive }">
                <a href="#" title="Agents">
                  <i class="la la-user"></i>
                  <span>Agents</span>
                  <span class="menu-arrow"></span>
                </a>
                <ul style="display: none;">
                  <li>
                    <router-link to="/agent/list" class="employees">All Agents</router-link>
                  </li>
                  <li>
                    <router-link to="/agent/monthly_agents_statistics" class="tickets">Monthly Statistics</router-link>
                  </li>
                  <li>
                    <router-link to="/agent/tasks" class="tickets">Tasks</router-link>
                  </li>
                </ul>
              </li>
              <li v-show="isOwner == true" :class="{ 'active': currentpage === '/toolkit/operator/list' }">
                <router-link to="/toolkit/operator/list" class="clients" title="Operator">
                  <i class="fa fa-user-secret"></i>
                  <span>Operator</span>
                </router-link>
              </li>
              <li v-show="isOwner == true" :class="{ 'active': currentpage === '/toolkit/link_generator/list' }">
                <router-link to="/toolkit/link_generator/list" class="clients" title="WA Rotator">
                  <i class="fa fa-rotate-right"></i>
                  <span>WA Rotator</span>
                </router-link>
              </li>
              <li v-show="isOwner == true" :class="{ 'active': currentpage === '/toolkit/widget/list' }">
                <router-link to="/toolkit/widget/list" class="clients" title="Widget Chat">
                  <i class="fa fa-window-maximize"></i>
                  <span>Widget Chat</span>
                </router-link>
              </li>

              <li class="menu-title" v-show="isOwner == true">
                <span>Analitik &amp; Laporan</span>
              </li>
              <li class="submenu" v-show="isOwner == true" :class="{ 'active': isReportsMenuActive }">
                <a href="#" title="Laporan">
                  <i class="la la-file"></i>
                  <span>Laporan</span>
                  <span class="menu-arrow"></span>
                </a>
                <ul style="display: none;">
                  <li>
                    <router-link to="/crm/tags/list" class="clients">
                      Tags
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/crm/window24hours/report" class="contacts" title="Jendela 24 Jam">
                      Jendela 24 Jam
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/message_report/inbox">Pesan Masuk</router-link>
                  </li>
                  <li>
                    <router-link to="/message_report/outbox">Pesan Keluar</router-link>
                  </li>
                  <li>
                    <router-link to="/message_report/reply_buttons" class="tickets">Text Reply</router-link>
                  </li>
                  <li>
                    <router-link to="/message_report/smart_reply" class="tickets">Chat Bot</router-link>
                  </li>
                  <li>
                    <router-link to="/license/summary" class="clients">Statistik Akun</router-link>
                  </li>
                </ul>
              </li>

              <li class="menu-title" v-show="isOwner == true">
                <span>Membership &amp; Integrasi</span>
              </li>
              <li class="submenu" v-show="isOwner == true" :class="{ 'active': isTransactionsMenuActive }">
                <a href="#" title="Transaksi">
                  <i class="la la-shopping-cart"></i>
                  <span>Transaksi</span>
                  <span class="menu-arrow"></span>
                </a>
                <ul style="display: none;">
                  <li>
                    <router-link to="/order/active_voucher" class="employees">Lunas</router-link>
                  </li>
                  <li>
                    <router-link to="/order/list" class="tickets">Semua</router-link>
                  </li>
                </ul>
              </li>
              <li v-if="isJoinAffiliate == false && isOwner == true" :class="{ 'active': currentpage === '/referral' }">
                <router-link to="/referral" class="contacts" title="Affiliate Program">
                  <i class="la la-sitemap"></i>
                  <span>Affiliate Program</span>
                </router-link>
              </li>
              <li v-if="isJoinAffiliate == true && isOwner == true" class="submenu"
                :class="{ 'active': isAffiliateMenuActive }">
                <a href="#" title="Affiliate Program">
                  <i class="la la-sitemap"></i>
                  <span>Affiliate Program</span>
                  <span class="menu-arrow"></span>
                </a>
                <ul>
                  <li>
                    <router-link to="/referral/link" class="referral">Referral Link</router-link>
                  </li>
                  <li>
                    <router-link to="/referral/commission" class="commission">Commission</router-link>
                  </li>
                  <li>
                    <router-link to="/referral/faq" class="commission">Faq</router-link>
                  </li>
                </ul>
              </li>

              <li class="menu-title">
                <span>Bantuan</span>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  :href="manualbook"
                  title="Petunjuk Penggunaan"
                >
                  <i class="la la-book"></i>
                  <span>Petunjuk Penggunaan</span>
                </a>
              </li>
              <li :class="{ 'active': currentpage === '/faq' }">
                <router-link to="/faq" class="faq" title="FAQ">
                  <i class="fa fa-question-circle-o"></i>
                  <span>FAQ</span>
                </router-link>
              </li>
            </ul>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <!-- </sidebar> -->
  </div>
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import { mapGetters } from "vuex";
import { hasPermissionForRoute } from "@/utils/helper";

export default {
  components: {
    vueCustomScrollbar
  },
  mounted() {
    $("#sidebar-menu a").on("click", function (e) {
      if (
        $(this)
          .parent()
          .hasClass("submenu")
      ) {
        e.preventDefault();
      }
      if (!$(this).hasClass("subdrop")) {
        $("ul", $(this).parents("ul:first")).slideUp(350);
        $("a", $(this).parents("ul:first")).removeClass("subdrop");
        $(this)
          .next("ul")
          .slideDown(350);
        $(this).addClass("subdrop");
      } else if ($(this).hasClass("subdrop")) {
        $(this).removeClass("subdrop");
        $(this)
          .next("ul")
          .slideUp(350);
      }
    });
    this.openActiveSubmenu();
  },
  watch: {
    "$route.path"() {
      this.openActiveSubmenu();
    }
  },
  computed: {
    isJoinAffiliate() {
      return this.$store.state.referral.isJoin;
    },
    ...mapGetters(["agentSession", "rolesMember"]),
    isOwner() {
      if (typeof this.agentSession.is_owner == "undefined") {
        return true;
      } else {
        if (this.agentSession.is_owner == 1) {
          return true;
        } else {
          return false;
        }
      }
    },
    currentpage() {
      // console.log("this.$route", this.$route);
      return this.$route.path;
    },
    isDashboardRoute() {
      return (
        this.currentpage === "/" ||
        this.currentpage === "/index" ||
        this.currentpage === "/copilot"
      );
    },
    isContactMenuActive() {
      const path = this.currentpage;

      return (
        path === "/contacts-v2" ||
        path === "/contacts-sync-v2" ||
        path.indexOf("/contacts-v2/") === 0 ||
        path.indexOf("/contacts-sync-v2/") === 0 ||
        path === "/contacts" ||
        path.indexOf("/contacts/") === 0
      );
    },
    isBroadcastMenuActive() {
      const path = this.currentpage;

      return (
        path.indexOf("/broadcast-") === 0 ||
        path === "/message_report/broadcast" ||
        path.indexOf("/message_report/broadcast/") === 0
      );
    },
    isFormsMenuActive() {
      return (
        this.currentpage === "/forms" ||
        this.currentpage.indexOf("/forms/") === 0
      );
    },
    isTagsMenuActive() {
      return this.currentpage.indexOf("/crm/tags") === 0;
    },
    isAgentsMenuActive() {
      return this.currentpage.indexOf("/agent/") === 0;
    },
    isReportsMenuActive() {
      return (
        [
          "/message_report/inbox",
          "/message_report/outbox",
          "/message_report/reply_buttons",
          "/message_report/smart_reply",
          "/license/summary"
        ].indexOf(this.currentpage) !== -1
      );
    },
    isTransactionsMenuActive() {
      return this.currentpage.indexOf("/order/") === 0;
    },
    isAffiliateMenuActive() {
      return (
        this.currentpage === "/referral" ||
        this.currentpage.indexOf("/referral/") === 0
      );
    }
  },
  data() {
    return {
      settings: {
        suppressScrollX: false
      },
      manualbook:
        process.env.VUE_APP_LINK_DOCS_WAAJO || "https://docs.waajo.id",
      activeClass: "active"
    };
    //  isactive : true
  },
  methods: {
    hasPermissionForRoute(roles, route) {
      return hasPermissionForRoute(roles, route);
    },
    openActiveSubmenu() {
      this.$nextTick(() => {
        const $submenus = $("#sidebar-menu > ul > li.submenu");
        if (!$submenus.length) {
          return;
        }

        const collapsed =
          $("body").hasClass("mini-sidebar") &&
          !$("body").hasClass("expand-menu");

        $submenus.each(function () {
          const $item = $(this);
          const isActive = $item.find("ul a.active").length > 0;
          $item.children("a:first").toggleClass("subdrop", isActive);

          const $list = $item.children("ul");
          if (isActive && !collapsed) {
            $list.stop(true, true).slideDown(0);
          } else {
            $list.stop(true, true).slideUp(0);
          }
        });
      });
    },
    scrollHanle(evt) {
      // console.log(evt);
    }
  }
};
</script>
<style scoped>
.sidebar .sidebar-menu>ul>li>a .sidebar-contact-icon {
  display: inline-block;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  transition: all 0.2s ease-in-out 0s;
}

.sidebar .sidebar-menu>ul>li>a .afu-beta-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  min-width: 30px;
  height: 18px;
  margin-left: 6px;
  padding: 0 7px;
  border: 1px solid rgba(254, 155, 68, 0.38);
  border-radius: 999px;
  background: #fff3e6;
  color: #b45309;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.02em;
  white-space: nowrap;
  vertical-align: middle;
}

@media (min-width: 768px) {
  .mini-sidebar .sidebar .sidebar-menu>ul>li>a .sidebar-contact-icon {
    flex-basis: 30px;
    width: 30px;
    height: 30px;
  }

  .mini-sidebar.expand-menu .sidebar .sidebar-menu>ul>li>a .sidebar-contact-icon {
    flex-basis: 20px;
    width: 20px;
    height: 20px;
  }
}

.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}

@media only screen and (max-width: 575.98px) {
  .sidebar-menu {
    padding-bottom: 100px;
  }
}

/* .ps__rail-y {
        top: 0px !important;
    height: 657px !important;
    right: -3px !important;
    background-color: transparent !important;
        } */
</style>


// WEBPACK FOOTER //
// src/components/layouts/Sidebar.vue